<template>
  <div>
    <childLogo></childLogo>
    <div class="container">
      <div class="navbar-dark">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">往届回顾</span>
          </div>
        </div>
        <div style="font-size: 17px;margin-bottom: 15px;color: #5e5e5e;text-align: center">{{ siteName }}</div>
       </div>
      <div class="list_box">
        <div class="list_item" v-for="(item,index) in rows" :key="index">
          <el-row :gutter="10" style="width: 100%;height: 100%; overflow: hidden;">
            <el-col :xs="24" :sm="14" :md="16" :lg="16" :xl="16">
              <img :src="item.coverUrl" width="100%" />
            </el-col>
            <el-col :xs="24" :sm="10" :md="8" :lg="8" :xl="8">
              <div style="padding: 10px;">
                <div style="font-size: 32px;color: #0040AB;">{{item.title}}</div>
                <div style="font-size: 18px;color:#aaaaaa;margin: 0 0 10px 0;">{{item.subTitle}}</div>
                <div v-html="item.brief"></div>
                <div style="float: right;margin-bottom:15px">
<!--                <a class="btn-review" :href="item.author" target="_blank">查看官网</a>-->
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";
import {siteMess} from "@/api/system/index"
export default {
  name: "Trends",
  components: {
    ChildLogo: ChildLogo
  },
  data() {
    return {
      siteName:"",
      rows: []
    };
  },
  created() {
    siteMess(this.siteURL,this.siteId).then(res=>{
      this.siteName = res.data.name;
    })
    //赛事资讯
 //   var api = this.siteURL + "/actuator/article/list?channelId=158";
    var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=PastReview";
    this.axios.get(api, {}).then(response => {
      this.rows = response.data.rows;
    });
  }
};
</script>

<style scoped>
.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0c70fc; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0c70fc;
}

.list_item {
  width: 100%;
  height: 80%;
  margin: 40px 0;
  border: solid #e9e9e9 2px;
}

.btn-review {
  display: block;
  width: 120px;
  height: 26px;
  color: #ffffff;
  background: #4a90e2;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/PastReview.vue